import React, { useState } from "react";


import {
  FaBookReader,
  FaChevronDown,
  FaChevronUp,
  FaCheck,
} from "react-icons/fa";

function EducationEdTechPage() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const sections = [
    {
      title: "Personalized Learning",
      points: [
        "Adaptive Learning Path Recommender",
        "AI Tutor for STEM Subjects",
        "Language Learning Chatbot",
        "Exam Readiness Analyzer",
        "Learning Style Identifier Agent",
      ],
    },

    {
      title: "Teacher Support & Admin",
      points: [
        "Lesson Plan Generator Agent",
        "Assignment Auto-Grader",
        "Plagiarism Detection Bot",
        "Student Performance Dashboard",
        "Attendance Monitoring Agent",
      ],
    },

    {
      title: "Institution-Level Tools",
      points: [
        "Admission Inquiry Chatbot",
        "Course Enrollment Optimizer",
        "Virtual Campus Tour Guide",
        "Student Dropout Predictor",
        "Fee Payment Reminder Agent",
      ],
    },

    {
      title: "e-Learning & Online Engagement",
      points: [
        "Interactive Lecture Transcriber",
        "Engagement Sentiment Analyzer",
        "Gamified Learning Agent",
        "Real-Time Translation Bot",
        "AI Voiceover for Video Lessons",
      ],
    },

    {
      title: "Inclusivity & Mental Wellness",
      points: [
        "Accessibility Enhancement Agent",
        "Dyslexia-Friendly Content Adapter",
        "Emotional Wellbeing Check-In Bot",
        "Career Counseling Assistant",
        "Mental Health Support Chatbot",
      ],
    },
  ];

  return (
    <>

      {/* Responsive styles for this page */}
      <style>{`
        .edtech-wrapper {
          background: #22c7b8;
          min-height: 100vh;
        }

        .edtech-hero {
          background: #173b8f;
          width: 100%;
        }

        .edtech-hero-inner {
          width: 92%;
          max-width: 1300px;
          margin: 0 auto;
          padding: 38px 0px;
        }

        .edtech-hero-top {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 16px;
        }

        .edtech-icon-box {
          width: 44px;
          height: 44px;
          background: #22c7b8;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .edtech-icon-box svg {
          color: #ffffff;
          font-size: 20px;
        }

        .edtech-title {
          color: #ffffff;
          font-size: 34px;
          font-weight: 700;
          margin: 0;
          font-family: "Exo", sans-serif;
          word-break: break-word;
        }

        .edtech-description {
          color: #f2f2f2;
          font-size: 15px;
          line-height: 1.9;
          max-width: 1000px;
          margin: 0;
        }

        .edtech-accordion-wrap {
          width: 92%;
          max-width: 1050px;
          margin: 0 auto;
          padding: 28px 0px 50px;
        }

        .edtech-card {
          background: #ffffff;
          border-radius: 8px;
          margin-bottom: 10px;
          overflow: hidden;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        }

        .edtech-card-header {
          padding: 14px 18px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          cursor: pointer;
          transition: 0.3s;
          gap: 10px;
        }

        .edtech-card-header.active {
          background: #173b8f;
        }

        .edtech-card-header.inactive {
          background: #ffffff;
        }

        .edtech-card-title {
          margin: 0;
          font-size: 16px;
          font-weight: 700;
          font-family: "Exo", sans-serif;
          word-break: break-word;
        }

        .edtech-card-title.active {
          color: #ffffff;
        }

        .edtech-card-title.inactive {
          color: #173b8f;
        }

        .edtech-chevron-active {
          color: #ffffff;
          font-size: 16px;
          flex-shrink: 0;
        }

        .edtech-chevron-inactive {
          color: #173b8f;
          font-size: 16px;
          flex-shrink: 0;
        }

        .edtech-card-content {
          padding: 18px 24px;
          background: #ffffff;
        }

        .edtech-point-row {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 12px;
        }

        .edtech-point-check {
          width: 24px;
          height: 24px;
          min-width: 24px;
          border-radius: 50%;
          background: #22c7b8;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .edtech-point-check svg {
          color: #ffffff;
          font-size: 10px;
        }

        .edtech-point-text {
          margin: 0;
          color: #4b5563;
          font-size: 15px;
          line-height: 1.7;
          font-weight: 500;
          word-break: break-word;
        }

        /* Tablets */
        @media (max-width: 1024px) {
          .edtech-hero-inner {
            padding: 32px 0px;
          }

          .edtech-title {
            font-size: 30px;
          }

          .edtech-accordion-wrap {
            width: 90%;
          }
        }

        /* Small tablets / large phones */
        @media (max-width: 768px) {
          .edtech-hero-inner {
            width: 90%;
            padding: 26px 0px;
          }

          .edtech-icon-box {
            width: 40px;
            height: 40px;
          }

          .edtech-icon-box svg {
            font-size: 18px;
          }

          .edtech-title {
            font-size: 26px;
          }

          .edtech-description {
            font-size: 14px;
            line-height: 1.8;
          }

          .edtech-accordion-wrap {
            width: 90%;
            padding: 22px 0px 40px;
          }

          .edtech-card-header {
            padding: 12px 16px;
          }

          .edtech-card-title {
            font-size: 15px;
          }

          .edtech-card-content {
            padding: 16px 18px;
          }
        }

        /* Mobile phones */
        @media (max-width: 480px) {
          .edtech-hero-inner {
            width: 88%;
            padding: 22px 0px;
          }

          .edtech-hero-top {
            gap: 10px;
            margin-bottom: 12px;
          }

          .edtech-icon-box {
            width: 36px;
            height: 36px;
            border-radius: 8px;
          }

          .edtech-icon-box svg {
            font-size: 16px;
          }

          .edtech-title {
            font-size: 21px;
          }

          .edtech-description {
            font-size: 13px;
            line-height: 1.7;
          }

          .edtech-accordion-wrap {
            width: 90%;
            padding: 18px 0px 32px;
          }

          .edtech-card {
            border-radius: 6px;
            margin-bottom: 8px;
          }

          .edtech-card-header {
            padding: 10px 14px;
          }

          .edtech-card-title {
            font-size: 14px;
          }

          .edtech-card-content {
            padding: 14px 14px;
          }

          .edtech-point-row {
            gap: 10px;
            margin-bottom: 10px;
          }

          .edtech-point-check {
            width: 20px;
            height: 20px;
            min-width: 20px;
          }

          .edtech-point-check svg {
            font-size: 9px;
          }

          .edtech-point-text {
            font-size: 13.5px;
            line-height: 1.6;
          }
        }

        /* Very small phones */
        @media (max-width: 360px) {
          .edtech-title {
            font-size: 18px;
          }

          .edtech-card-title {
            font-size: 13px;
          }

          .edtech-point-text {
            font-size: 13px;
          }
        }
      `}</style>

      <div className="edtech-wrapper">
        {/* HERO SECTION */}
        <div className="edtech-hero">
          <div className="edtech-hero-inner">
            <div className="edtech-hero-top">
              <div className="edtech-icon-box">
                <FaBookReader />
              </div>

              <h1 className="edtech-title">Education & EdTech</h1>
            </div>

            <p className="edtech-description">
              The education sector spans academic institutions,
              training centers, and e-learning platforms. AI agents
              support adaptive learning, automated grading,
              personalized tutoring, and student mental health—
              enhancing both teaching and learning experiences.
            </p>
          </div>
        </div>

        {/* ACCORDION SECTION */}
        <div className="edtech-accordion-wrap">
          {sections.map((section, index) => {
            const isActive = openIndex === index;
            return (
              <div key={index} className="edtech-card">
                {/* HEADER */}
                <div
                  onClick={() => toggle(index)}
                  className={`edtech-card-header ${
                    isActive ? "active" : "inactive"
                  }`}
                >
                  <h2
                    className={`edtech-card-title ${
                      isActive ? "active" : "inactive"
                    }`}
                  >
                    {section.title}
                  </h2>

                  {isActive ? (
                    <FaChevronUp className="edtech-chevron-active" />
                  ) : (
                    <FaChevronDown className="edtech-chevron-inactive" />
                  )}
                </div>

                {/* CONTENT */}
                {isActive && (
                  <div className="edtech-card-content">
                    {section.points.map((point, i) => (
                      <div key={i} className="edtech-point-row">
                        <div className="edtech-point-check">
                          <FaCheck />
                        </div>

                        <p className="edtech-point-text">{point}</p>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}

export default EducationEdTechPage;
